// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./confirm_dialog" // design-v2 styled replacement for native turbo_confirm
import "./controllers"

import "cropperjs/dist/cropper.css"
import "trix"
import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

